export enum MeasurementSystem {
  METRIC = "metric",
  IMPERIAL = "imperial",
}
